import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_SETTINGS, SCAMP_API } from 'src/environments/environment';
import { CommandResult } from '../pages/domain/commandResult';
import { Local } from '../pages/domain/domain.model';
import { AccountService } from './account.service';



@Injectable({providedIn: 'root'})
export class LocalService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    getLocaisTodos(): Observable<Local[]> {
        return this.http.get<Local[]>(`${SCAMP_API.accountApiV1}/locais-todos-cb`, { headers: this.account.composeHeaders() });
    }

    getLocaisNaoPredio(): Observable<Local[]> {
        return this.http.get<Local[]>(`${SCAMP_API.accountApiV1}/locais-nao-predio`, { headers: this.account.composeHeaders() });
    }

    // TODO: Elimar serviço predioService e substituir o método getPredio por este onde for usado (avaliar-spv)
    getLocaisPredio(): Observable<Local[]> {
        return this.http.get<Local[]>(`${SCAMP_API.accountApiV1}/predios-cb`, { headers: this.account.composeHeaders() });
    }

    setOutroLocalDeTrabalho(dado): Observable<any> {
        return this.http.post(`${SCAMP_API.accountApiV1}/outro-local`, dado, { headers: this.account.composeHeaders() });
    }

    isUniqueNomeLocal(nome: string): Observable<boolean> {
        return this.http.get<boolean>(`${SCAMP_API.accountApiV1}/is-unique-nome-local/${nome}`, { headers: this.account.composeHeaders() });
    }



    create(data: CommandResult) {
        return this.http.post<CommandResult>(`${SCAMP_API.accountApiV1}/local`, data,
            { headers: this.account.composeHeaders() });
    }

    getById(id: number): Observable<Local> {
        return this.http.get<Local>(`${SCAMP_API.accountApiV1}/local/${id}`, { headers: this.account.composeHeaders() });
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/local/${id}`, data, { headers: this.account.composeHeaders() });
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/local/${id}`, { headers: this.account.composeHeaders() });
    }

    list(): Observable<Local[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/locais-todos-cb`, { headers: this.account.composeHeaders() });
    }

    getAll(): Observable<Local[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/locais`, { headers: this.account.composeHeaders() });
    }


    listSubstacoes(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/substacoes`, { headers: this.account.composeHeaders() });
    }


    isUniqueCodigoSubstacao(codigo: string): Observable<boolean> {
        return this.http.get<boolean>(`${SCAMP_API.accountApiV1}/is-unique-codigo-substacao/${codigo}`,
            { headers: this.account.composeHeaders() });
    }

    search(parametro: string, tipoLocal: number): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/locais-search/${parametro}/${tipoLocal}`,
            { headers: this.account.composeHeaders() });
    }

    getLocaisByGroupLevelOne(grupoLocalNivel1Id: number): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/locais-by-group-level-one/${APP_SETTINGS.tipoLocal}/${grupoLocalNivel1Id}`,
            { headers: this.account.composeHeaders() });
    }

    getLocaisByGrupoLocalNivelId(grupolocalid: number): Observable<Local[]> {
        return this.http.get<Local[]>(`${SCAMP_API.accountApiV1}/locais/por-grupolocalnivelid/${APP_SETTINGS.tipoLocal}/${grupolocalid}`,
            { headers: this.account.composeHeaders() });
    }

    getNextId(): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/locais/next-id`, {headers : this.account.composeHeaders()});
    }


}
